module.exports = __webpack_public_path__ + "static/media/notification-icon-unread.29398fae.svg";